export default __webpack_public_path__ + "static/media/featuredDesktop.7192dc43.png";